'use client';

import { useState } from 'react';
import { useMeasure } from 'react-use';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Typography, Box, Collapse, Button, Stack } from '@mui/material';
import { Rotate } from '@qb/frontend/components/Rotate';
import { clampLinesSx } from '@qb/frontend/utils/clampLinesSx';
import { convertStringToParagraphs } from '@qb/frontend/utils/convertStringToParagraphs';
import { PartDisplayDataResponse } from '@/shared/types/controllers/sps/SPSPartControllerTypes';
const SEE_MORE_BUTTON_HEIGHT = 30;
const COLLAPSE_MIN_HEIGHT = 109 + SEE_MORE_BUTTON_HEIGHT;
const FOUR_LINES_HEIGHT = 84;
type PartDescriptionCollapseProps = Pick<PartDisplayDataResponse['part'], 'description' | 'manufacturer' | 'partNumber'> & Pick<PartDisplayDataResponse, 'partCategoriesToRoot'>;
export const PartDescriptionCollapse = ({
  description
}: PartDescriptionCollapseProps) => {
  const [expanded, setExpanded] = useState(false);
  const [ref, {
    height
  }] = useMeasure();
  const isLongText = height >= FOUR_LINES_HEIGHT;
  return <Box sx={{
    mt: 'auto',
    position: 'relative',
    minHeight: COLLAPSE_MIN_HEIGHT,
    zIndex: 1,
    mx: -2
  }} data-sentry-element="Box" data-sentry-component="PartDescriptionCollapse" data-sentry-source-file="PartDescriptionCollapse.tsx">
      <Collapse in={expanded} collapsedSize={COLLAPSE_MIN_HEIGHT} sx={{
      px: 2,
      position: ['static', 'static', 'absolute'],
      bgcolor: 'common.white'
    }} data-sentry-element="Collapse" data-sentry-source-file="PartDescriptionCollapse.tsx">
        <Typography variant="h5" sx={{
        mb: 0.5
      }} data-sentry-element="Typography" data-sentry-source-file="PartDescriptionCollapse.tsx">
          Product description
        </Typography>
        <Box ref={ref} data-sentry-element="Box" data-sentry-source-file="PartDescriptionCollapse.tsx">
          <Typography variant="paragraph" align="justify" sx={{
          whiteSpace: 'pre-line',
          ...(expanded ? {} : clampLinesSx(4))
        }} data-sentry-element="Typography" data-sentry-source-file="PartDescriptionCollapse.tsx">
            {convertStringToParagraphs(description)}
          </Typography>
        </Box>
        <Stack data-sentry-element="Stack" data-sentry-source-file="PartDescriptionCollapse.tsx">
          <Button size="small" variant="text" color="primary" onClick={() => setExpanded(!expanded)} aria-expanded={expanded} aria-label="show more" sx={{
          ml: 'auto',
          visibility: isLongText ? 'visible' : 'hidden'
        }} disabled={!isLongText} endIcon={<Rotate isRotated={expanded}>
                <ExpandMoreIcon />
              </Rotate>} data-sentry-element="Button" data-sentry-source-file="PartDescriptionCollapse.tsx">
            Read more
          </Button>
        </Stack>
      </Collapse>
    </Box>;
};